import React, { useEffect, useState } from 'react'

import LoadingDots from '../LoadingDots'
import { EmbraceHeartIcon } from './EmbraceHeartIcon'
import { EmbraceHeartContainer } from './styles'

export interface EmbraceHeartLoaderProps {
  size?: number
  isFullPage?: boolean
  loadingDots?: { enabled: boolean; size?: number }
  flexDirection?: 'row' | 'column'
  className?: string
}

const EmbraceHeartLoader: React.FC<EmbraceHeartLoaderProps> = ({
  size = 100,
  isFullPage,
  loadingDots,
  flexDirection = 'column',
  className,
}) => {
  const [iteration, setIteration] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIteration((prev) => prev + 1)
    }, 2200)
    return () => clearInterval(intervalId)
  }, [setIteration])

  return (
    <EmbraceHeartContainer
      $size={size}
      $isFullPage={isFullPage}
      $flexDirection={flexDirection}
      className={`embrace-heart-loader${className ? ` ${className}` : ''}`}
    >
      <EmbraceHeartIcon key={iteration} />
      {loadingDots?.enabled && (
        <LoadingDots className="loading-dots" size={loadingDots?.size / 22 || size / 22} withText />
      )}
    </EmbraceHeartContainer>
  )
}

export default EmbraceHeartLoader
